export default __webpack_public_path__ + "static/media/avatar2.352a7718.jpeg";